<template>
  <div class="video-item">
    <div class="video-bbs">
      <div class="user">
        <img :src="commentData.userAvatar" :class="{ 'img-sub': !styleFlag }" />
        <span>{{ commentData.userName }}</span>
        <em v-if="!styleFlag">{{
          commentData.userTag ? commentData.userTag : "未知"
        }}</em>
      </div>
      <div class="desc">
        <em v-if="styleFlag">{{ commentData.userTag ? commentData.userTag : "未知" }}</em
        >{{ commentData.content }}
      </div>
      <div class="footer clearfix">
        <!-- <div class="goods-wrap" v-if="styleFlag">
          <img src="@/assets/img/user/goods.png" class="goods" />
          <span>···</span>
          <span>{{ commentData.likeSize }}人已点赞</span>
        </div> -->
        <div class="good-wrap" :class="{ sub: !styleFlag }">
          <img src="@/assets/img/user/good.png" class="good" />点赞({{
            commentData.likeSize
          }})
          <img src="@/assets/img/user/msg.png" style="opacity: 0.4" class="good" />
          <span v-if="styleFlag">评论({{ commentData.childComment.length }})</span>
          <span v-if="!styleFlag">回复</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReplyItem",
  props: {
    styleFlag: {
      type: Boolean,
      default: true,
    },
    data: Object,
    len: Number,
  },
  computed: {
    commentData() {
      return this.data;
    },
  },
};
</script>

<style lang="scss">
.video-item {
  .video-bbs {
    margin: 0 18px 20px 0;
    padding: 7px 0 14px 11px;
    &:nth-of-type(3n) {
      margin-right: 0;
    }
    .user {
      margin-bottom: 10px;
      img {
        width: 58px;
        height: 58px;
        border-radius: 50%;
      }
      .img-sub {
        width: 34px;
        height: 34px;
        border-radius: 50%;
      }
      span {
        display: inline-block;
        line-height: 34px;
        font-size: 17px;
        color: #7f7f7f;
        vertical-align: middle;
        margin: 0 40px 0 21px;
      }
      em {
        display: inline-block;
        width: 90px;
        height: 25px;
        line-height: 25px;
        border: 1px solid #3fbce9;
        font-size: 15px;
        color: #3fbce9;
        border-radius: 2px;
        margin-right: 6px;
        text-align: center;
        vertical-align: middle;
      }
    }
    .desc {
      margin: 0 0 20px 53px;
      line-height: 29px;
      font-size: 15px;
      color: #aaa;
      word-break: break-all;
      em {
        display: inline-block;
        width: 90px;
        height: 25px;
        line-height: 25px;
        border: 1px solid #3fbce9;
        font-size: 15px;
        color: #3fbce9;
        border-radius: 2px;
        margin-right: 14px;
        text-align: center;
        vertical-align: unset;
      }
    }
    .footer {
      padding: 12px 0 0 53px;
      font-size: 15px;
      line-height: 23px;
      color: #aaa;
      img {
        vertical-align: text-bottom;
      }
      .good {
        width: 19px;
        height: 19px;
        // vertical-align: top;
        margin: 0 7px 0 23px;
        filter: invert(1);
      }
      .goods {
        width: 51px;
        height: 23px;
      }
      span {
        display: inline-block;
        margin: 0 15px 0 11px;
        line-height: 23px;
      }
      .goods-wrap {
        float: left;
      }
      .good-wrap {
        float: right;
        font-size: 15px;
        line-height: 23px;
        &.sub {
          float: right;
          margin-left: -23px;
        }
      }
      em {
        margin-right: 10px;
        color: #3fbce9;
        cursor: pointer;
      }
    }
  }
}
</style>
